import Vue from 'vue'
import Router from 'vue-router'
import IndexView from '../views/index.vue'
import ProtocolItem from '../views/protocol-item.vue'
import NoCode from '../views/noCode.vue'
Vue.use(Router)
export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'IndexView',
      component: IndexView,
    },
    {
      path: '/',
      name: 'ProtocolItem',
      component: ProtocolItem,
    },
    {
      path: '/',
      name: 'NoCode',
      component: NoCode,
    },
  ],
})
